import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { CommonStepAttributes } from '../../ui/utils/analytics/analyticsFlowTypes';

import { META_UPDATE_COMMON_ATTRIBUTES } from './ai-monitor-watchmen-plugin';

export const getMonitorWatchmenCommands = ({ dispatch, state }: EditorView) => ({
	syncCommonAttributes: (attributes: Partial<CommonStepAttributes>) =>
		dispatch(state.tr.setMeta(META_UPDATE_COMMON_ATTRIBUTES, attributes)),
});
